import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import { ddmmyy, dateToTime } from "../utils/DateUtils";

import { CustomStyles } from "../component/CustomStyle";
import { android2, macintosh2, windows2, linux2 } from "../iconsImports";
import AuthContext from "../store/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import CachedIcon from "@mui/icons-material/Cached";
import FilterCard from "../modals/FilterCard";
import AddUserKey from "./AddUserKey";
import ApiEndpoints from "../network/ApiEndPoints";
import EditUserKey from "./EditUserKey";
import AddUserService from "./AddUserService";
import EditUserService from "./EditUserService";
let refresh;
const UserServices = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [openAddKey, setOpenAddKey] = useState(false);
  const [openEditKey, setOpenEditKey] = useState(false);
  const [editData, setEditData] = useState(null);

  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const columns = [
    {
      name: "Created At",
      selector: (row) => (
        <div>
          {ddmmyy(row.created_at)}
          <br />
          {dateToTime(row.created_at)}
        </div>
      ),
    },
    {
      name: "User ID",
      selector: (row) => row.user_id,
    },

    // 🔹 SERVICES
    { name: "DMT", selector: (row) => row.dmt },
    { name: "DMT 2", selector: (row) => row.dmt2 },
    {
      name: "Account Verification",
      selector: (row) => row.acc_verification,
    },
    { name: "Payout", selector: (row) => row.payout },
    { name: "Mobile", selector: (row) => row.mobile },
    { name: "DTH", selector: (row) => row.dth },
    {
      name: "Card Bill",
      selector: (row) => row.card_bill,
    },
    {
      name: "Wallet Transfer",
      selector: (row) => row.wallet_transfer,
    },
    { name: "BBPS", selector: (row) => row.bbps },
    { name: "AEPS", selector: (row) => row.aeps },
    {
      name: "Nepal Transfer",
      selector: (row) => row.nepal_transfer,
    },
    { name: "UPI", selector: (row) => row.upi },
    { name: "Rem KYC", selector: (row) => row.remKyc },
    { name: "OKYC", selector: (row) => row.okyc },
    {
      name: "Utility OFF",
      selector: (row) => row.utility_off,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Tooltip title="Edit Services">
          <IconButton
            size="small"
            color="primary"
            onClick={() => {
              setEditData(row);
              setOpenEditKey(true);
            }}
          >
            <EditIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  function refreshFunc(setQuery) {
    setQuery("");
    if (refresh) refresh();
  }

  return (
    <Box>
      <Grid>
        <ApiPaginateSearch
          showSearch={false}
          isFilterAllowed={true}
          filterComponent={
            <>
              <FilterCard
                ifdescriptionFilter
                setQuery={setQuery}
                query={query}
                clearHookCb={(cb) => {
                  refresh = cb;
                }}
                refresh={refresh}
                actionButtons={
                  <>
                    <AddUserService
                      open={openAddKey}
                      handleClose={() => setOpenAddKey(false)}
                      onSuccess={() => {
                        setOpenAddKey(false);
                        refreshFunc(setQuery); // auto refresh table
                      }}
                    />

                    <Tooltip title="refresh">
                      <IconButton
                        aria-label="refresh"
                        // color="success"
                        sx={{
                          color: "#0F52BA",
                        }}
                        onClick={() => {
                          refreshFunc(setQuery);
                        }}
                      >
                        <CachedIcon className="refresh-purple" />
                      </IconButton>
                    </Tooltip>
                  </>
                }
              />
            </>
          }
          apiEnd={ApiEndpoints.GET_USER_SERVICES}
          columns={columns}
          apiData={apiData}
          setApiData={setApiData}
          tableStyle={CustomStyles}
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
        />
        <EditUserService
          open={openEditKey}
          data={editData}
          handleClose={() => {
            setOpenEditKey(false);
            setEditData(null);
          }}
          onSuccess={() => {
            setOpenEditKey(false);
            setEditData(null);
            refreshFunc(setQuery);
          }}
        />
      </Grid>
    </Box>
  );
};

export default UserServices;
